// Restart prompt, chapter panel and chapter unlocking.
import { cam, controls } from '../core/scene.js';
import { setTilt } from '../core/post.js';
import { treeTime } from '../world/trees.js';
import { S, START, ovFly } from './ride.js';
import { introCam } from './intro.js';
import { STOPS } from '../data/stops.js';
import { loc, tr } from '../ui/lang.js';
import { isUnlocked } from '../rules/chapters.js';
import { renderChapters, stopPrompt, visited } from './stop-markers.js';
import { toggleStop } from './stops.js';
import { state } from '../core/state.js';
import { bBack, bReset, chapters, go, hint, introSub, panel, speed } from '../dom.js';

export let resetGame, askReset, openStop, unlocked;

export function buildStopPanel() {
  // back to the opening shot: bike parked on the promenade, chapters cleared
  // keep = true restarts the ride but leaves the chapters already seen unlocked (and ticked)
  resetGame = function resetGame(keep = false) {
    Object.assign(S, START, { v: 0, steer: 0 });
    state.camHead = S.th;
    state.camDist = 15;
    state.panelOpen = false;
    panel.classList.remove('open');
    if (!keep) visited.clear();
    renderChapters();
    STOPS.forEach((st, i) => {
      const c = visited.has(i) ? 0x3ddc84 : st.color;
      st.ringMat.color.set(c);
      st.beam.material.color.set(c);
    });
    state.mode = 'intro';
    controls.enabled = false;
    controls.autoRotate = false;
    document.body.classList.remove('riding');
    cam.fov = 58;
    cam.updateProjectionMatrix();
    setTilt(0.45, 0.6);
    introCam(treeTime.value);
    go.style.display = '';
    introSub.style.display = '';
    chapters.style.display = 'none';
    speed.style.display = 'none';
    bBack.style.display = 'none';
    ovFly.on = false;
    hint.textContent = tr('hint');
  };
  askReset = function askReset() {
    if (!visited.size) {
      resetGame();
      return;
    } // nothing to keep
    resetAsk.querySelector('.q').textContent = tr('resetQ');
    resetAsk.querySelector('.keep').textContent = tr('resetKeep');
    resetAsk.querySelector('.fresh').textContent = tr('resetFresh');
    resetAsk.querySelector('.cancel').textContent = tr('resetCancel');
    resetAsk.classList.add('open');
    resetAsk.querySelector('.keep').focus();
  };
  openStop = function openStop(i) {
    const st = loc(STOPS[i]);
    state.panelOpen = true;
    state.openIdx = i;
    visited.add(i);
    renderChapters();
    STOPS[i].ringMat.color.set(0x3ddc84);
    STOPS[i].beam.material.color.set(0x3ddc84);
    const done = visited.size === STOPS.length;
    panel.innerHTML = `<button class="x" aria-label="×">×</button>${st.logo ? `<img class="logo${st.logo.dark ? ' dark' : ''}" src="${st.logo.src}" alt="">` : ''}<div class="k">${tr('chapter')} ${i + 1} · ${st.k}</div><h2>${st.title}</h2><div class="role">${st.role} · ${st.place}</div>
    <p class="lead">${st.lead}</p>${st.sections.map(([h, items]) => `<h3>${h}</h3><ul>${items.map((t) => `<li>${t}</li>`).join('')}</ul>`).join('')}<div class="tags">${st.tags.map((t) => `<span>${t}</span>`).join('')}</div>
    <div class="close">${done ? tr('done') : ''}${tr('close')}</div>`;
    panel.querySelector('.x').onclick = () => toggleStop(true);
    panel.classList.add('open');
    stopPrompt.style.display = 'none';
  };
  // restarting asks first: keep the chapters seen so far, or start the story from zero
  const resetAsk = document.getElementById('resetAsk');
  const closeAsk = () => resetAsk.classList.remove('open');
  resetAsk.querySelector('.keep').onclick = () => {
    closeAsk();
    resetGame(true);
  };
  resetAsk.querySelector('.fresh').onclick = () => {
    closeAsk();
    resetGame(false);
  };
  resetAsk.querySelector('.cancel').onclick = closeAsk;
  bReset.onclick = () => {
    askReset();
    bReset.blur();
  };
  // a chapter can be opened once every earlier one has been seen (and seen ones can always be reread)
  unlocked = (i) => isUnlocked(i, visited, STOPS.length);
}
